<fullscreen-page>
  <content-column *ngIf="template" look="dark" [helpSwitch]="true">
    <div slot="content" class="d-flex flex-column h-100 p-2 overflow-auto">
      <div class="d-flex m-3 gap-2">
        <dx-button
          *ngIf="catalogId"
          stylingMode="text"
          type="default"
          text="{{ 'Zurück zum Katalog' | translate }}"
          [routerLink]="['/catalog', customerId, catalogId]"
        ></dx-button>
        <dx-button
          *ngIf="!catalogId"
          stylingMode="text"
          type="default"
          text="{{ 'Zurück zur Template Liste' | translate }}"
          routerLink="/templates"
        ></dx-button>
      </div>

      <div *ngIf="template.templateType !== 'SAP_ARIBA'" class="border rounded bg-white mx-3 mb-3">
        <div
          class="kopf-panel-header d-flex align-items-center justify-content-between px-3 py-2 user-select-none"
          (click)="toggleHeaderVisible()"
        >
          <span class="fw-semibold">{{ 'Kopfeinstellungen' | translate }}</span>
          <div class="d-flex align-items-center gap-3">
            <dx-switch
              [(value)]="template.useMetadata"
              (onValueChanged)="onUseMetadataChanged()"
              (click)="$event.stopPropagation()"
              hint="{{ 'Kopfeinstellungen hinzufügen' | translate }}"
            ></dx-switch>
            <i
              *ngIf="template.useMetadata"
              class="dx-icon"
              [ngClass]="isHeaderVisible ? 'dx-icon-chevronup' : 'dx-icon-chevrondown'"
            ></i>
          </div>
        </div>
        <div class="p-3" *ngIf="template.useMetadata && isHeaderVisible">
          <np-advanced-template-header [template]="template" (onUpdate)="update()"></np-advanced-template-header>
        </div>
      </div>

      <div class="d-flex align-items-center mx-3 mb-2">
        <h5 class="m-0">{{ 'Tabellenblätter' | translate }}</h5>
      </div>

      <div class="d-flex flex-grow-1 worksheet-layout" style="min-height: 0">
        <div class="worksheet-sidebar d-flex flex-column p-2 gap-1 overflow-auto border-end">
          <div
            *ngFor="let data of sheetItemWrapper; let index = index"
            class="worksheet-item d-flex align-items-center gap-1 p-2 rounded user-select-none"
            [class.worksheet-item-active]="sheetIndex === index"
            (click)="onSelectSheet(index)"
          >
            <dx-text-box
              *ngIf="sheetNameEditorIndex == index && !$any(data).isHeader"
              class="flex-grow-1"
              [(value)]="data.name"
              (onValueChanged)="onSaveWorksheetRename($event)"
            ></dx-text-box>
            <span *ngIf="sheetNameEditorIndex != index || $any(data).isHeader" class="flex-grow-1 text-truncate">
              {{ data.name }}
              <span *ngIf="!$any(data).isHeader">({{ data.templateItems?.length }})</span>
            </span>
            <dx-button
              *ngIf="sheetNameEditorIndex == index && !$any(data).isHeader"
              icon="check"
              stylingMode="text"
              (onClick)="onConfirmWorksheetRename(); $event.event?.stopPropagation()"
            ></dx-button>
            <dx-button
              *ngIf="sheetNameEditorIndex == index && !$any(data).isHeader"
              icon="close"
              stylingMode="text"
              (onClick)="onCancelWorksheetRename(index); $event.event?.stopPropagation()"
            ></dx-button>
            <dx-button
              *ngIf="sheetNameEditorIndex != index && !$any(data).isHeader"
              icon="edit"
              stylingMode="text"
              (onClick)="sheetNameEditorIndex = index; $event.event?.stopPropagation()"
            ></dx-button>
            <dx-button
              *ngIf="sheetNameEditorIndex != index && !$any(data).isHeader"
              icon="remove"
              stylingMode="text"
              (onClick)="onRemoveWorksheet(index); $event.event?.stopPropagation()"
            ></dx-button>
          </div>

          <dx-button
            *ngIf="template.templateType !== 'SAP_ARIBA'"
            class="mt-1"
            stylingMode="text"
            type="default"
            icon="add"
            text="{{ 'Tabelle hinzufügen' | translate }}"
            (onClick)="onAddWorksheet()"
          ></dx-button>
        </div>

        <div class="flex-grow-1 d-flex flex-column overflow-auto p-2" style="min-width: 0">
          <ng-container *ngFor="let data of sheetItemWrapper; let index = index">
            <ng-container *ngIf="sheetIndex === index">
              <np-advanced-template-header
                *ngIf="$any(data).isHeader"
                [template]="template"
                (onUpdate)="update()"
              ></np-advanced-template-header>
              <np-advanced-template-datagrid
                *ngIf="!$any(data).isHeader"
                [ngStyle]="{ height: 'inherit', display: 'flex', 'flex-direction': 'column' }"
                [customerId]="customerId"
                [sheetIndex]="template.templateType == 'SAP_ARIBA' ? 0 : index"
                [(template)]="template"
                [wawiListMapping]="wawiListMapping"
                [languageFlags]="languageFlags"
                [warrantyClasses]="warrantyClasses"
                [hazmatClasses]="hazmatClasses"
                [validFeatureSystems]="validFeatureSystems"
                (onUpdate)="update($event)"
              ></np-advanced-template-datagrid>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </content-column>
</fullscreen-page>
